import { Input } from '@/presentation/components/input'
import type { HTMLAttributes } from 'react'
import type { AutoFormWidgetsProps } from '../autoForm'
import { FieldDescription } from '../description'
import { Field } from '../field'
import { FieldControl } from '../fieldControl'
import { FieldLabel } from '../label'
import { FieldMessage } from '../message'

type DataAttributes = {
  // Permite atributos `data-*` (ex: data-vaul-no-drag) em objetos de props
  // sem precisar fazer casts no uso.
  [k: `data-${string}`]: string | number | boolean | undefined
}

type InputWidgetProps = AutoFormWidgetsProps & {
  type: string
  initialValue?: HTMLAttributes<HTMLInputElement>['defaultValue']
  inputRef?: React.Ref<HTMLInputElement>
  inputProps?: Omit<
    React.InputHTMLAttributes<HTMLInputElement> & DataAttributes,
    'type' | 'defaultValue' | 'name' | 'id'
  >
}

export const InputWidget = (props: InputWidgetProps) => {
  return (
    <Field path={props.path} className={props.classNames?.root}>
      <FieldLabel>
        {props.options?.label as string}
        <FieldDescription>{props.options?.description as string}</FieldDescription>
      </FieldLabel>
      <FieldControl>
        <Input
          step={props.type === 'number' ? '0.01' : undefined}
          className="bg-white"
          placeholder={props.options?.placeholder as string | undefined}
          type={props.type}
          defaultValue={props.initialValue}
          ref={props.inputRef}
          {...props.inputProps}
        />
      </FieldControl>
      <FieldMessage />
    </Field>
  )
}
